import React, { useState, useEffect } from "react";
import "./index.css";
import { Menu, Button, message } from "antd";
import { getCustomerId } from "../../Common";
import { track, flushThenLeave } from "statsig";
import { STATSIG, PAGE } from "statsig/events";



const BillingManagement = () => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        track(STATSIG.COMMON.VIEW, PAGE.BILLING_MANAGEMENT, { page: PAGE.BILLING_MANAGEMENT });
    }, []);

    const handleContinue = async () => {
        const customerId = getCustomerId();
        if (!customerId) {
            message.error("Unable to get customer ID");
            return;
        }

        setLoading(true);
        try {
            const token = sessionStorage.getItem("ZeitroA");
            const response = await fetch("/api/v1/los/stripe/createPortalSessionFromCustomerID", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify({
                    customerId: customerId,
                }),
            });

            if (response.ok) {
                const data = await response.json();
                if (data.url) {
                    track(STATSIG.BILLING_MANAGEMENT.CONTINUE);
                    await flushThenLeave(() => {
                        window.location.href = data.url;
                    });
                } else {
                    message.error("No portal URL received");
                }
            } else {
                const errorData = await response.json().catch(() => ({ error: "Unknown error" }));
                message.error(errorData.error || "Failed to create portal session");
            }
        } catch (error) {
            console.error("Error creating portal session:", error);
            message.error("Failed to create portal session");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='mx-3'>

            <div className='User_title mt-4 mb-3 ml-4 mr-5 Support'>
                <div>
                    Billing Management
                </div>
                {/* <div >
                    <Button className='ant-btn-default-zeitro' onClick={() => {


                        setSupportModalOpen(true)
                    }}>Support</Button>
                </div> */}

            </div>
            <div className="Billing_title ml-4">How to access the following features in your Zeitro Billing Portal powered by Stripe</div>
            <div className="Billing_content ml-4">
                <div className="ul_content">
                    <ul>
                        <li>View current plan</li>
                        <li>View invoice history</li>
                        <li>Update billing information</li>
                        <li>Update payment method</li>
                    </ul>
                </div>

                <div>
                    <img src="/images/stripe.svg"></img>
                </div>
            </div>
            <div className="Billing_bottom ml-4 mt-4">
                <div style={{ color: '#797979', }}>Please follow these steps</div>
                <ol>
                    <li>Click <span style={{ color: ' #325CEB', cursor: 'pointer' }}>Continue</span> to be redirected to the Billing Portal.</li>
                    <li>Manage your billing information, subscription, and payment methods.</li>
                </ol>
            </div>


            <div className="billingButton">

                <Button 
                    type='primary' 
                    style={{
                        height: "44px", 
                        width: '220px',
                    }} 
                    onClick={handleContinue}
                    loading={loading}
                >
                    Continue
                </Button>
            </div>
        </div>
    );
};

export default BillingManagement;
